document.addEventListener("turbolinks:load", function() {
    if($("body").data("controller") == "registrations" || $("body").data("controller") == "clients" || $("body").data("controller") == "sessions" ) {

        $('#btn-register').on("click", function(e) {
            e.preventDefault()
            
            const forms = document.querySelectorAll('#new_user')
            let isValid = false
        
            $("#new_user").validate()
            
            Array.prototype.slice.call(forms).forEach(function (form) {
                if (form.value == "") {
                    form.classList.add('is-invalid')
                    isValid = false
                    event.preventDefault()
                    event.stopPropagation()
                }

                form.classList.add('was-validated')
            }, false)

            if (checkVin($("#vin").val()) == false) {
                return false
            }

            if ($("#new_user").valid()) {
                $(".car_alert-zone").addClass("d-none")
                $(".car_alert-zone .alert").text("")
                $(".errors").html("")

                $("#btn-register").attr("disabled", true)
                $(".spinner-register").removeClass("d-none")

                // check car validity
                let formData = new FormData();
                formData.append('brand_model_id', $("#car_model").val());
                formData.append('car_number', $("#car_number").val());
                formData.append('vin]', $("#vin").val());
               
                $("#btn-save-profil").attr("disabled", true)
                $("#btn-save-profil .spinner-border ").removeClass("d-none")

                fetch(`/clients/check-car`, {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'default',
                    body: formData,
                }).then(function(response) {
                    if (response.ok) {
                        response.json().then(function(data) {

                            if (($("#user_password").val() != $("#user_password_confirmation").val()) || $("#user_password").val().length < 8 ) {
                                $(".errors").html(`
                                    <div id="error_explanation">
                                        <div class="alert alert-danger text-sm-start ">
                                            <ul>
                                                <li>Le Mot de passe est incorrecte!</li>
                                                <li>Le Mot de passe doit contenir au moins 8 caractères!</li>
                                            </ul>
                                        </div>
                                    </div>
                                `)

                                $("#btn-register").attr("disabled", false)
                                $(".spinner-register").addClass("d-none")

                                return
                            }
                            else {
                                document.getElementById("new_user").submit()
                            }
                        })
                    }
                    else {
                        response.json().then(function(data) {
                            $("#btn-register").attr("disabled", false)
                            $(".spinner-register").addClass("d-none")

                            $(".car_alert-zone").removeClass("d-none")
                            $(".car_alert-zone .alert").text(data.error)

                            return
                        })
                    }
                });
            }

        })
        
        $('#user_phone').mask('(216) 99 999999');
        $('#register-car-phone').mask('(216) 99 999999');
        $('#user_login_phone').mask('(216) 99 999999');


        $("#user_login_phone").on("click", function() {
            let tel = document.getElementById("user_login_phone");
            tel.focus()
            tel.setSelectionRange(6, 6);
        })
      
        $("#user_phone").on("click", function() {
            let tel = document.getElementById("user_phone");
            tel.focus()
            tel.setSelectionRange(6, 6);
        })

        $("#vin").on("change", function() {
            let vin = $(this).val()

            checkVin(vin)
        })

        function checkVin(vin) {
            if (isNaN(vin.slice(-5, 17)) == true) {
                $(".car_alert-zone").removeClass("d-none")
                $(".car_alert-zone .alert").text("Numéro de châssis est invalide!")

                return false
            }
            else {
                $(".car_alert-zone").addClass("d-none")
                $(".car_alert-zone .alert").text("")

                return true
            }
        }

        let modal_mdp_recovery;
        if (document.getElementById("modal-mdp_recovery") != null) {
            modal_mdp_recovery = new bootstrap.Modal(document.getElementById("modal-mdp_recovery"), {backdrop: 'static', keyboard: false});

            $("[name='recovery[phone]']").mask('(216) 99 999999');
            
            $("#btn-mdp_recovery").on("click", function() {
                modal_mdp_recovery.show()  
            })

            $("#btn-send").on("click", function() {
                let phone = $("[name='recovery[phone]']").val().trim()
                if (phone != "") {
                    $(".recovery-spinner").removeClass("d-none")
                    $("[name='recovery[phone]']").attr("disabled", true)
                    $("btn-send").attr("disabled", true)
                    $("#btn-cancel-recovery").attr("data-bs-dismiss", "")
                    
                    let formData = new FormData();
                    formData.append('phone', phone);

                    fetch(`/clients/exists`, {
                        method: 'POST',
                        mode: 'cors',
                        cache: 'default',
                        body: formData,
                    }).then(function(response) {
                        if (response.ok) {
                            response.json().then(function(data) {
                                if (data.exists == true) {
                                    Swal.fire({
                                        title: "Récupération de mot de passe",
                                        text: `Un SMS sera envoyé contenant un nouveau mot de passe. Voulez-vous continuer?`,
                                        icon: 'question',
                                        showCancelButton: true,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        cancelButtonText: 'Annuler',
                                        confirmButtonText: 'Oui',
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        showLoaderOnConfirm: true,
                                        preConfirm: () => {
                                            return fetch(`/clients/mdp_recovery`, {
                                                method: 'POST',
                                                mode: 'cors',
                                                cache: 'default',
                                                body: formData,
                                            }).then(function(response) {
                                                if (response.ok) {
                                                    response.json().then(function(data) {
                                                        $(".recovery-spinner").addClass("d-none")
                                                        $("[name='recovery[phone]']").attr("disabled", false)
                                                        $("btn-send").attr("disabled", false)
                                                        $("#btn-cancel-recovery").attr("data-bs-dismiss", "modal")
                                                        $("[name='recovery[phone]']").val("")

                                                        modal_mdp_recovery.hide()

                                                        Swal.fire({
                                                            title: "Nouveau mot de passe envoyé! Vérifier votre boite SMS.",
                                                            icon: "success",
                                                            draggable: true
                                                        });
                                                    })
                                                }
                                            })
                                        },
                                    }).then((result) => {
                                        if (result.dismiss == "cancel") {
                                            $(".recovery-spinner").addClass("d-none")
                                            $("[name='recovery[phone]']").attr("disabled", false)
                                            $("btn-send").attr("disabled", false)
                                            $("#btn-cancel-recovery").attr("data-bs-dismiss", "modal")
                                        }
                                    })
                                }
                                else {

                                    Swal.fire({
                                        title: "Numéro de téléphone introuvable!",
                                        icon: "error",
                                        draggable: true
                                    });

                                    $(".recovery-spinner").addClass("d-none")
                                    $("[name='recovery[phone]']").attr("disabled", false)
                                    $("btn-send").attr("disabled", false)
                                    $("#btn-cancel-recovery").attr("data-bs-dismiss", "modal")
                                }
                            })
                        }
                    })
                }
            })
        }

        
    }
})